import { UntypedFormGroup, Validators } from '@angular/forms';

export class PreinvoicePaymentValidators {
  static apply(form: UntypedFormGroup, payTypeLabel: string, consts: any): void {
    const bankCtrl = form.get('bankAccountUid');
    const cashCtrl = form.get('cashRegisterUid');
    const partnerCtrl = form.get('partnerUid');

    if (bankCtrl) bankCtrl.clearValidators();
    if (cashCtrl) cashCtrl.clearValidators();
    if (partnerCtrl) partnerCtrl.clearValidators();

    if (PreinvoicePaymentValidators.isBankAccountPayment(payTypeLabel, consts) && bankCtrl) {
      bankCtrl.setValidators([Validators.required]);
    }

    if (PreinvoicePaymentValidators.isCashRegisterPayment(payTypeLabel) && cashCtrl) {
      cashCtrl.setValidators([Validators.required]);
    }

    if (PreinvoicePaymentValidators.isPartnerPayment(payTypeLabel) && partnerCtrl) {
      partnerCtrl.setValidators([Validators.required]);
    }

    if (bankCtrl) bankCtrl.updateValueAndValidity({ emitEvent: false });
    if (cashCtrl) cashCtrl.updateValueAndValidity({ emitEvent: false });
    if (partnerCtrl) partnerCtrl.updateValueAndValidity({ emitEvent: false });
  }

  static isBankAccountPayment(payTypeLabel: string, consts: any): boolean {
    const t = payTypeLabel || '';
    return [
      consts.TYPEPAY_BANKTRANSFERENCE,
      consts.TYPEPAY_SEPA,
      consts.TYPE_TARJETA,
      consts.TYPEPAY_CONFIRMING,
      consts.TYPEPAY_PAGARES,
      'Bizum',
      'Transferencia bancaria'
    ].indexOf(t) >= 0;
  }

  static isCashRegisterPayment(payTypeLabel: string): boolean {
    return (payTypeLabel || '') === 'Efectivo';
  }

  static isPartnerPayment(payTypeLabel: string): boolean {
    return (payTypeLabel || '') === 'Socio';
  }
}
